module.exports = __webpack_public_path__ + "img/spbu6.931d1f65.png";